// Moment.js localization plugin
// This plugin provides Moment.js localization support with fallback options

let moment = null

// Try to import moment, but don't fail if it's not available
try {
  moment = require('moment')
} catch (error) {
  console.warn('Moment.js not found, skipping localization setup:', error.message)
}

export function setupMomentLocales(i18n) {
  if (!moment) {
    console.warn('Moment.js not available, skipping locale setup')
    return
  }

  try {
    // Set default locale
    moment.locale(i18n.locale)
    
    console.log('Moment.js localization configured successfully')
  } catch (error) {
    console.error('Failed to setup Moment.js localization:', error)
  }
}

// Function to update Moment.js locale manually
export function updateMomentLocale(locale) {
  if (!moment) {
    console.warn('Moment.js not available for locale update')
    return false
  }

  try {
    moment.locale(locale)
    console.log(`Moment.js locale changed to: ${locale}`)
    return true
  } catch (error) {
    console.warn(`Failed to change Moment.js locale to ${locale}:`, error.message)
    // Fallback to English
    try {
      moment.locale('en')
      return true
    } catch (fallbackError) {
      console.error('Failed to set fallback locale:', fallbackError)
      return false
    }
  }
}

// Custom moment formatting functions with error handling
export function formatDate(date, format = 'L', locale = null) {
  if (!moment) {
    console.warn('Moment.js not available for date formatting')
    return date ? new Date(date).toLocaleDateString() : ''
  }

  try {
    const targetLocale = locale || 'en'
    return moment(date).locale(targetLocale).format(format)
  } catch (error) {
    console.warn('Date formatting failed, using fallback:', error.message)
    return date ? new Date(date).toLocaleDateString() : ''
  }
}

export function formatRelativeTime(date, locale = null) {
  if (!moment) {
    console.warn('Moment.js not available for relative time formatting')
    return date ? new Date(date).toLocaleDateString() : ''
  }

  try {
    const targetLocale = locale || 'en'
    return moment(date).locale(targetLocale).fromNow()
  } catch (error) {
    console.warn('Relative time formatting failed, using fallback:', error.message)
    return date ? new Date(date).toLocaleDateString() : ''
  }
}

// Fallback date formatting using native JavaScript
export function formatDateFallback(date, options = {}) {
  if (!date) return ''
  
  try {
    const defaultOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      ...options
    }
    
    return new Date(date).toLocaleDateString(undefined, defaultOptions)
  } catch (error) {
    console.warn('Fallback date formatting failed:', error.message)
    return date.toString()
  }
}

// Check if moment is available
export function isMomentAvailable() {
  return !!moment
}